const _config = {
    dev: {
        URI: "http://localhost:2023",
    },
    sandbox: {
        URI: "https://s5mjqh6euw.ap-southeast-1.awsapprunner.com",
    },
    production: {
        URI: "https://w2g363ejxz.ap-southeast-1.awsapprunner.com",
    }
}
// NOTE: This branch defaults to the sandbox backend.
// Set REACT_APP_TARGET=dev for localhost or REACT_APP_TARGET=production for prod.
// When merging to main, consider reverting the non-production default back to "dev".
const TARGET =
    process.env.REACT_APP_TARGET ||
    (process.env.NODE_ENV === "production" ? "production" : "sandbox");
const config = {
    defaultImage : "https://s3-ap-southeast-1.amazonaws.com/rgk-images/17tts_head_maxi_lc.png", 
    ..._config[TARGET],
}



export default config;
